import { ApiAxios } from '../Configs/Api';
const UseGetData = (url, params, header) => {
    
    const config = {
        headers: {
            ...header
        }, params
    }
    return ApiAxios.get(url, config);
}
export default UseGetData;